import React from 'react';
import { Box } from '@mui/material';

import AmSatelliteImageryLegend from '../../../../components/SatelliteCharts/AmSatelliteImageryLegend';
import AmSatelliteTilePlotMap from '../../../../components/SatelliteCharts/AmSatelliteTilePlotMap';
import useMapLoading from '../../../../hooks/useMapLoading';

const AmSatelliteReportMapSection = ({ tile, polygon, activeTile }) => {
  const { setIsLoading, MapEventsHandler } = useMapLoading();

  return (
    <Box
      sx={{
        width: '100%',
        gap: 2,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        '@media print': {
          gap: '2mm',
          pageBreakInside: 'avoid',
        },
      }}
    >
      <Box
        sx={{
          width: '33%',
          '@media print': {
            width: '35%',
          },
        }}
      >
        <AmSatelliteTilePlotMap
          tile={tile}
          polygon={polygon}
          activeTile={activeTile}
          MapEventsHandler={MapEventsHandler}
          setIsLoading={setIsLoading}
          zoom={16}
          height="200px"
        />
      </Box>
      <Box
        sx={{
          width: '66%',
          '@media print': {
            width: '65%',
          },
        }}
      >
        <AmSatelliteImageryLegend activeTile={activeTile} />
      </Box>
    </Box>
  );
};

export default AmSatelliteReportMapSection;
